import { EventType, Importance } from '@blisspointmedia/bpm-types/dist/OracleActivity';
import { BandConfig } from '@blisspointmedia/bpm-types/dist/OracleApi';
import {
  DerivedEventFields,
  EventTaxonomy,
  EventTaxonomyEntry,
  EventTheme
} from './oracle-taxonomy-constants';

export { EventTaxonomy } from './oracle-taxonomy-constants';
export type { DerivedEventFields } from './oracle-taxonomy-constants';

const importanceFromWeight = (weight: number | null, bands: BandConfig): Importance => {
  if (weight === null) return Importance.NONE;
  const { weights } = bands;
  if (weights.high.includes(weight)) return Importance.HIGH;
  if (weights.medium.includes(weight)) return Importance.MEDIUM;
  if (weights.low.includes(weight)) return Importance.LOW;
  return Importance.NONE;
};

export const deriveEventFields = (eventType: EventType, bands: BandConfig): DerivedEventFields => {
  const { theme, signalTag, weight } = EventTaxonomy[eventType];
  const importance = importanceFromWeight(weight, bands);
  return { theme, signalTag, weight, importance };
};

// The BFF passes unrecognized wire event types through unchanged, so the lookup can miss at runtime.
export const getEventTheme = (eventType: EventType): EventTheme => {
  const entry: EventTaxonomyEntry | undefined = EventTaxonomy[eventType];
  return entry?.theme ?? 'Other';
};
